// Please use the regex recommendation provided by the W3C spec when validating email addresses.
// https://html.spec.whatwg.org/multipage/input.html#email-state-(type=email)
export const emailValidationRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
